module.exports = __webpack_public_path__ + "static/media/icon_user_orange.acf7760b.svg";